// Interface para dados de entrada do formulário de salário líquido
interface SalaryInputData {
  readonly salarioBruto: string;
  readonly numeroDependentes: string;
  readonly dependentesMenores14: string;
  readonly pensaoAlimenticia: string;
  readonly outrosDescontos: string;
}

// Interface para resultado do cálculo de INSS
interface INSSResultType {
  readonly valor: number;
  readonly baseCalculo: number;
  readonly aliquotaEfetiva: number;
}

// Interface para resultado do cálculo de IRRF
interface IRRFResultType {
  readonly valor: number;
  readonly baseCalculo: number;
  readonly deducaoDependentes: number;
}

// Interface para resultado do salário-família
interface SalarioFamiliaResultType {
  readonly temDireito: boolean;
  readonly valor: number;
  readonly quantidadeDependentes: number;
  readonly observacao: string | null;
}

// Interface para resultado completo do cálculo de salário líquido
interface SalaryResultsType {
  readonly salarioBruto: number;
  readonly inss: INSSResultType;
  readonly irrf: IRRFResultType;
  readonly pensaoAlimenticia: number;
  readonly outrosDescontos: number;
  readonly salarioFamilia: SalarioFamiliaResultType;
  readonly totalDescontos: number;
  readonly salarioLiquido: number;
  readonly percentualLiquido: number;
}

// Mensagens de validação para salário líquido
const ValidationMessages = {
  SALARIO_OBRIGATORIO: "Informe o salário bruto.",
  SALARIO_INVALIDO: "Salário bruto deve ser maior que zero.",
  DEPENDENTES_INVALIDOS: "Dependentes menores não pode exceder total de dependentes.",
  ERRO_CALCULO: "Erro no cálculo. Verifique os dados informados.",
} as const;

// Constantes trabalhistas 2025 para cálculo de salário líquido
const CONSTANTES_2025 = {
  SALARIO_MINIMO: 1518.00,
  TETO_INSS: 8157.41,
  VALOR_DEPENDENTE_IRRF: 189.59,
  SALARIO_FAMILIA: 65.00,
  TETO_SALARIO_FAMILIA: 1906.04,
} as const;

// Export das interfaces e tipos
export type {
  SalaryInputData,
  SalaryResultsType,
  INSSResultType,
  IRRFResultType,
  SalarioFamiliaResultType,
};

export { ValidationMessages, CONSTANTES_2025 };